<ng-container *ngFor="let opt of to.options">
  <div class="form-check">
    <p>dqsdqsd</p>
    <input class="form-check-input" type="radio" [formControl]="formControl" [formlyAttributes]="field" value="{{opt.value}}" style="margin-bottom: 5px;" >
    <label class="form-check-label" >
      {{opt.label}}
    </label>
  </div>
</ng-container>
